import { SIDENAV_TOKENS } from '@app/components/layout/sidenav/sidenav-tokens';
import { AnchorPosition } from '@app/core/hooks';
import { Box, Popover, Typography } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const emptyNotificationsMessage = defineMessage({
  id: 'core.sidenav.notificationsEmpty',
  defaultMessage: 'No hay notificaciones',
});

export type SidenavNotificationsPopoverProps = {
  open: boolean;
  anchorPosition: AnchorPosition | undefined;
  onClose: () => void;
};

/**
 * Empty-state notifications panel opened from the sidenav bell button.
 */
export function SidenavNotificationsPopover({
  open,
  anchorPosition,
  onClose,
}: SidenavNotificationsPopoverProps) {
  const $t = useIntl().formatMessage;

  return (
    <Popover
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      marginThreshold={0}
      slotProps={{
        paper: {
          sx: {
            bgcolor: 'background.paper',
            color: 'text.primary',
            minWidth: SIDENAV_TOKENS.drawerWidth,
          },
        },
      }}
    >
      <Box sx={{ px: 2, py: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
          {$t(emptyNotificationsMessage)}
        </Typography>
      </Box>
    </Popover>
  );
}
